import strOverflow from "@/utils/strOverflow";
import Head from "next/head";
export default function PinHead({ pin }) {
  return (
    <>
      <Head>
        <title>
          {pin
            ? `${pin?.raw_text}图片_${pin?.board?.title}图片素材-花瓣网`
            : "采集-花瓣网"}
        </title>
        {!!pin && (
          <meta
            name="description"
            content={`${strOverflow(pin?.raw_text, 40)}图片是${
              pin?.user?.username
            }的${pin?.board?.title}画板中的相关图片之一的详情图，${
              pin?.board?.title
            }画板共有${
              pin?.board?.pin_count
            }张设计师收藏采集的相关图片素材资源。花瓣网, 设计师寻找灵感的天堂！`}
          />
        )}
      </Head>
    </>
  );
}
